import React from 'react'
import moment from 'moment'
import {
  Description,
  Image,
  ImageContainer,
  StepContainer,
  Title,
} from 'Components/SharedComponents/Surveys/Surveys.styled'
import { ActionElementType } from 'Components/SharedComponents/Surveys/constants'
import { NextActions } from 'Components/SharedComponents/Surveys/NextActions/NextActions'
import { ButtonAction } from 'Components/SharedComponents/Surveys/types'
import { CheckInSurveyEvent } from 'Modules/Analytics/trackActionInterface/Surveys/checkIn'
import getStarted from '../_assets/getStarted.png'
import {
  HandleActionArgs,
  HandleFireAnalytics,
  PartialUserSurvey,
} from '../types'
import { CheckInWizardStep } from '../constants'

type GetStartedProps = {
  onAnyAction: ({ nextStep, callback }: HandleActionArgs) => void
  onFireAnalytics: HandleFireAnalytics
  userSurvey: PartialUserSurvey
}

export const GetStarted = ({
  onAnyAction,
  onFireAnalytics,
  userSurvey,
}: GetStartedProps) => {
  const nextActions: ButtonAction[] = [
    {
      callback: () => onFireAnalytics(CheckInSurveyEvent.Start_Survey_Clicked),
      label: 'Get Started',
      path: CheckInWizardStep.REVIEW_PREVIOUS_PRIORITIES,
      type: ActionElementType.BUTTON,
    },
  ]

  const date = moment.utc(userSurvey.completedAt).format('MM/DD/YYYY')

  return (
    <StepContainer>
      <Title>Let’s check in on your organization’s progress</Title>
      <Description>
        On {date}, we asked you to identify your priorities and establish a
        baseline. Now, it&apos;s time for an update! <br />
        This 8-minute survey will gather insights to enhance your organization’s
        impact measurements.
      </Description>
      <ImageContainer>
        <Image src={getStarted} />
      </ImageContainer>
      <NextActions nextActions={nextActions} onAnyAction={onAnyAction} />
    </StepContainer>
  )
}
